import * as React from "react"
import {CSSProperties} from "react"
import {ShowTestModeBand} from "../graphql/queries"
import {GraphQL} from "../graphql"

export function TestModeBand(props: {}) {
  return (
    <GraphQL.Query
      query={ShowTestModeBand}
      variables={{}}
      render={({data}) => {
        // Is showing nothing if the query is still loading the right thing to do?
        // I don't really want production users to see a loading spinner flash just for this feature.
        if (data && data.showTestModeBand) {
          const style: CSSProperties = {
            textAlign: "center",
            backgroundColor: "#d01919",
            fontWeight: 900,
            fontFamily: "sans-serif",
            fontSize: "8pt",
            lineHeight: "15px",
            color: "#ffffff",
            letterSpacing: "5px",
          }
          return <div style={style}>TEST MODE</div>
        } else {
          return null
        }
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/TestModeBand.tsx